export function generateMerchantImage(merchant, isEgiftsPage) {
    if (!isEgiftsPage) {
        return merchant.merchantImageUrl
    }

    if (isEgiftsPage && merchant.name === 'Visa') {
        return 'https://marketingcdn.giftcardgranny.com/merchant-images/lg/virtual_visa.png'
    }

    if (isEgiftsPage && merchant.name === 'Mastercard') {
        return 'https://marketingcdn.giftcardgranny.com/merchant-images/lg/virtual_mc.png'
    }

    return merchant.merchantImageUrl
}

export function generateMerchantCloudinaryId(merchant, isEgiftsPage) {
    if (!isEgiftsPage) {
        return merchant.cloudinaryId
    }

    if (isEgiftsPage && merchant.name === 'Visa') {
        return 'GCG/merchants/virtual_visa'
    }

    if (isEgiftsPage && merchant.name === 'Mastercard') {
        return 'GCG/merchants/virtual_mc'
    }

    return merchant.cloudinaryId
}
